import { yesNoOptionEnum } from '@/gen/types/YesNoOption';

import { whenPathEquals } from './conditions';
import type { IncidentFieldRule } from './types';

export const chemicalSpillEmissionsFieldRules: IncidentFieldRule[] = [
    {
        key: 'subCategory',
        label: 'How was the substance released?',
        description: 'Select how the release occurred, e.g. spill, leak, emission.',
        order: 90,
    },
    {
        key: 'spillProduct',
        label: 'Which product was involved?',
        description: 'Select the product or substance involved.',
        order: 100,
    },
    {
        key: 'spillFullyRecovered',
        label: 'Was the spill fully recovered?',
        description: 'Yes if the spill has been fully contained and cleaned up.',
        order: 110,
    },
    {
        key: 'environmentalExposure',
        label: 'Where did the spill reach?',
        description: 'Select all areas the spill reached, e.g. soil, water, drainage.',
        order: 120,
    },
    {
        key: 'humanExposureToChemical',
        label: 'Were any people exposed to the substance?',
        description: 'Yes if anyone had direct contact with the substance.',
        order: 130,
    },
    {
        key: 'humanExposureToChemicalExplanation',
        label: 'Human exposure explanation',
        kind: 'textarea',
        order: 140,
        visibleWhen: whenPathEquals('humanExposureToChemical', yesNoOptionEnum.Yes),
        requiredWhen: whenPathEquals('humanExposureToChemical', yesNoOptionEnum.Yes),
    },
    {
        key: 'estimatedVolume',
        label: 'Estimated volume released',
        description: 'Enter the estimated volume of the substance released and units (i.e. 100 L).',
        order: 150,
    },
    {
        key: 'unplannedEmission',
        label: 'Did this cause unplanned CO2 emissions?',
        description: 'Select Yes if the incident caused unexpected CO2 or greenhouse gas release.',
        order: 160,
    },
];
